export default __webpack_public_path__ + "assets/icons/word.52c8562e.svg";